import { Box, Typography } from "@mui/material";
import "./CohortLevelBar.css";

const CohortLevelBar = ({ levels, showCohortMetric }) => {
  const total = levels.reduce((acc, l) => acc + l.count, 0);
  const getLevelWidth = (count, total) => {
    if (count === 0) return "10px";
    return `max(${(count / total) * 100}%, 20px)`;
  };

  return (
    <Box className="cohort-level-bar-container">
      {showCohortMetric && (
        <Box className="cohort-level-bar-metric">
          {levels.map((level) => (
            <Box className="cohort-level-bar-metric-label" key={level.id}>
              <img
                src={level.icon}
                alt={level.label}
                className="cohort-level-bar-icon"
              />
              <Box className="cohort-label-row">
                <Box
                  className={`cohort-level-bar-metric-text cohort-level-bar-${level.className}-bg-color`}
                />
                <Typography className="cohort-level-bar-text">
                  {level.label}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Box className="cohort-level-bar">
        {levels.map((level) => (
          <Box
            className={`cohort-individual-level-bar cohort-level-bar-${level.className}-bg-color`}
            key={level.id}
            sx={{
              width: getLevelWidth(level.count, total),
            }}
          />
        ))}
      </Box>

      <Box className="cohort-level-bar-count">
        {levels.map((level) => (
          <Box
            className="cohort-level-bar-count-text"
            key={level.id}
            sx={{
              width: getLevelWidth(level.count, total),
            }}
          >
            <Typography className="cohort-bar-count">{level.count}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CohortLevelBar;
